export function normalizeLang(lang) {
	if (!lang || lang === 'CN' || lang === 'zh_CN') return 'zh-CN'
	if (lang === 'EN' || lang === 'en_GB') return 'en-US'
	return lang
}

export function getStoredLang() {
	const raw = localStorage.getItem('feiliks-language')
	const normalized = normalizeLang(raw) || 'zh-CN'
	if (raw && raw !== normalized) {
		localStorage.setItem('feiliks-language', normalized)
	}
	return normalized
}
